import { AnalyticIndex, EventEditor } from "../views";

export const analyticRouter = [
  {
    path: "analytic/",
    name: "AnalyticIndex",
    component: AnalyticIndex
  },
  {
    path: "analytic/event/",
    name: "EventEditor",
    component: EventEditor
  }
];
